export default {"src":"/_next/static/media/pass-circle-color.a01a80fb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};